import get from "lodash/get";
import { Img } from "./Image";
import { Link } from "./Link";

export class Block {
  constructor(node) {
    //console.log(node);
    const type = get(node, `__typename`);
    this.title = get(node, `title`);
    this.type = type;
    this.bodyCopy = get(node, `bodyCopy.json`);
    this.hideTitle = get(node, `hideTitle`);
    this.showAsAccordion = get(node, `showAsAccordion`);
    this.snapImage = new Img(get(node, `snapImage`));
    this.menuItems = get(node, `menuItems`, []).map((m) => new Link(m));
  }
}
